import type { InfoDocumento } from '@/shared/lib';
import type { VerificationDetailConfig } from '../config';

export interface VerificationCardSource {
  requestDate: string;
  code: string;
  title: string;
  revisionLabel: string;
  elaboratedBy: string;
  approvedBy: string;
  approvalDate: string;
}

export function buildRegistrationElaborationInfo(
  config: VerificationDetailConfig,
  source: VerificationCardSource
): InfoDocumento[] {
  return [
    { label: 'Data da solicitação', value: source.requestDate },
    { label: config.codeFieldLabel, value: source.code },
    { label: 'Título', value: source.title },
    { label: 'Revisão', value: source.revisionLabel },
    { label: 'Elaboração', value: source.elaboratedBy },
  ];
}

export function buildRegistrationApprovalInfo(
  source: VerificationCardSource
): InfoDocumento[] {
  return [
    { label: 'Data da Aprovação', value: source.approvalDate },
    { label: 'Aprovação', value: source.approvedBy },
  ];
}
